export default __webpack_public_path__ + "static/undraw_personal_opinions-bb2c3c8580f09289519d54463342d237.png";